/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  $('.popup__inner .standard__cta').click(function(e){
    e.preventDefault();
    $('.popup__inner').addClass('popup-hide');
    $.cookie('acceptcookie', 'true', { expires: 7 });
  });
  var cookieValue = $.cookie('acceptcookie');
  if(cookieValue){
    $('.popup__inner').addClass('popup-hide');
  }
  else{
    $('.popup__inner').addClass('popup-show');
  }

  var min_quantity = function() {
    let quantity_input = document.querySelector('.product__submit .quantity__input');
    let min = parseInt(quantity_input.getAttribute('min'));
    if(quantity_input.value < min) {
      quantity_input.value = min;
      quantity_input.dispatchEvent(new Event('change'));
    }
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    var metafields_data = JSON.parse(document.getElementById('MetafieldJson').textContent);
    if (variant) {
      let quantity_input = container.querySelector('.quantity__input');
      quantity_input.setAttribute("min", metafields_data[variant.id]);
      quantity_input.value = metafields_data[variant.id];
      if(metafields_data[variant.id] > 1) {
        document.querySelector('.product__minimum_order').style.opacity = 1;
        document.querySelector('.product__minimum_order span').innerHTML = metafields_data[variant.id];
      } else {
        document.querySelector('.product__minimum_order').style.opacity = 0;
      }
      quantity_input.dispatchEvent(new Event('change'));
    }
  });

  if(document.querySelector('.product__submit [data-quantity-input]')) {
    document.querySelector('.product__submit [data-quantity-input]').addEventListener('change', min_quantity);
  }
  
  // Collection description truncate
  if(document.querySelector('.collection__description')) {
    var collection__description = document.querySelector('.collection__description');
    console.log(collection__description.scrollHeight)
    if(collection__description.scrollHeight <= 55) {
      collection__description.classList.remove('has-readmore');
      collection__description.classList.add('no-readmore');
    }
    document.querySelector('.collection__description-readmore').addEventListener('click', function(e){
      e.preventDefault();
      collection__description.classList.toggle('is-opened');
      if (collection__description.style.maxHeight) {
        collection__description.style.maxHeight = null;
        this.innerHTML = "Read more";
      } else {
        collection__description.style.maxHeight = collection__description.scrollHeight + "px";
        this.innerHTML = "Read less";
      } 
    });
  }
  
})();
